// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import "./../../bindings/foreach-selection";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TreeNodeViewModel from "./../../factories/tree-node";
function ExplorerFilterTypeTicketCategory(parent) {
    var self = this;
    self.Bao = Bao;
    self.ColumnName = ko.observable("");
    self.SelectedDetailsRow = ko.observable();
    self.ToolbarButtons = ko.observableArray();
    self.DetailCollection = ko.observableArray();
    self.SearchType = ko.observable();
    self.SelectedValue = ko.observable();
    self.SelectedObjectId = ko.observable();
    self.SelectedItem = ko.observableArray();
    self.ObjectValue = ko.observable();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedDetailsRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedItem.subscribe(function (newValue) {
        if (newValue != null && self.ObjectValue() != null) {
            var tempArray = [];
            tempArray[0] = {
                Key: newValue.TicketCategoryStructureId,
                Value: newValue.CompleteTicketCategoryStructure
            };
            self.AddToSession(tempArray);
        }
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "actionFilterDefinitionTicketCategoryAdd":
                self.Add();
                break;
            case "actionFilterDefinitionTicketCategoryRemove":
                self.Remove();
                break;
        }
    };
    self.Add = function () {
        self.OpenTreeDialog();
    };
    self.Remove = function () {
        parent.DirtyFlag(true);
        parent.TabPage.IsLoading(true);
        return Bao.post("ExplorerFilter/RemoveExplorerFilterDefinitionDataSourceDetail", JSON.stringify({
            id: self.SelectedDetailsRow().ObjectId,
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function () {
            self.Refresh();
        });
    };
    self.AddToSession = function (selectedItems) {
        parent.DirtyFlag(true);
        parent.TabPage.IsLoading(true);
        return Bao.post("ExplorerFilter/AddExplorerFilterDefinitionDataSourceDetail", JSON.stringify({
            selectedItems: selectedItems,
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function () {
            self.Refresh();
        });
    };
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "actionFilterDefinitionTicketCategoryRemove":
                    button.Enabled(self.SelectedDetailsRow() != null);
                    break;
            }
        });
    };
    self.OpenTreeDialog = function () {
        parent.TabPage.IsLoading(true);
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: "TicketCategory"
        }), function (value) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogViewModel : any = {};
            dialogViewModel.NodeToggled = function (node) {
                if (node.Loaded() == false) {
                    parent.TabPage.IsLoading(true);
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({
                        type: "TicketCategory",
                        parentId: parentId
                    }), function (value) {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                        parent.TabPage.IsLoading(false);
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedCategory = ko.observable();
            dialogViewModel.SelectedCategory.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                parent.TabPage.IsLoading(true);
                var selectedNode;
                selectedNode = dialogViewModel.SelectedCategory();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketCategoryStructure", JSON.stringify({
                            selectedTicketCategoryId: selectedNode.Id()
                        }), function (result) {
                            self.SelectedObjectId(result.TicketCategoryStructureId);
                            self.SelectedItem(result);
                            dialog.Close();
                            parent.TabPage.IsLoading(false);
                        });
                    }
                }
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketCategoryInvalidSelection"), "info");
                parent.TabPage.IsLoading(false);
                return null;
            };
            dialog.Width(500);
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Enabled: ko.observable(true),
                    Click: dialogViewModel.okClick
                }]);
            dialog.Open();
            parent.TabPage.IsLoading(false);
            dialog.SetPosition();
        });
    };
    self.Refresh = function () {
        parent.TabPage.IsLoading(true);
        return Bao.post("ExplorerFilter/GetExplorerFilterDefinitionDataSource", JSON.stringify({
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            explorerFilterId: parent.ExplorerFilterId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function (result) {
            if (result != null && result.Model != null) {
                self.DetailCollection(result.Model.DetailCollectionFiltered);
            }
            parent.TabPage.IsLoading(false);
        });
    };
    self.loaded = function () {
        if (parent != null && parent.ExplorerFilterDefinitionDataSource() != null) {
            var dataSource = parent.ExplorerFilterDefinitionDataSource();
            self.DetailCollection(dataSource.DetailCollectionFiltered);
            self.SearchType(dataSource.SearchType);
            self.ColumnName(dataSource.ColumnName);
            self.ObjectValue(dataSource.ObjectValue);
        }
    };
}
export default ExplorerFilterTypeTicketCategory;